// Slice para manejar el estado de los links de referido de embajadores
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Estado para generar link de referido
  referralLink: null,
  isLoadingGenerateLink: false,
  errorGenerateLink: null,
  
  // Estado para validar código de referido
  validationResult: null,
  isLoadingValidation: false,
  errorValidation: null,
  
  // Estado para trackear click
  trackResult: null,
  isLoadingTrack: false,
  errorTrack: null,
  
  // Estado para obtener mis links
  myReferralLinks: [],
  isLoadingMyLinks: false,
  errorMyLinks: null,
};

const referralLinkSlice = createSlice({
  name: "referralLink",
  initialState,
  reducers: {
    // Generate Link
    generateLinkStart: (state) => {
      state.isLoadingGenerateLink = true;
      state.errorGenerateLink = null;
    },
    generateLinkSuccess: (state, action) => {
      state.referralLink = action.payload;
      state.isLoadingGenerateLink = false;
      state.errorGenerateLink = null;
    },
    generateLinkFailure: (state, action) => {
      state.isLoadingGenerateLink = false;
      state.errorGenerateLink = action.payload;
    },
    
    // Validate Code
    validateCodeStart: (state) => {
      state.isLoadingValidation = true;
      state.errorValidation = null;
    },
    validateCodeSuccess: (state, action) => {
      state.validationResult = action.payload;
      state.isLoadingValidation = false;
      state.errorValidation = null;
    },
    validateCodeFailure: (state, action) => {
      state.isLoadingValidation = false;
      state.errorValidation = action.payload;
    },
    
    // Track Click
    trackClickStart: (state) => {
      state.isLoadingTrack = true;
      state.errorTrack = null;
    },
    trackClickSuccess: (state, action) => {
      state.trackResult = action.payload;
      state.isLoadingTrack = false;
      state.errorTrack = null;
    },
    trackClickFailure: (state, action) => {
      state.isLoadingTrack = false;
      state.errorTrack = action.payload;
    },
    
    // Get My Links
    getMyLinksStart: (state) => {
      state.isLoadingMyLinks = true;
      state.errorMyLinks = null;
    },
    getMyLinksSuccess: (state, action) => {
      state.myReferralLinks = action.payload;
      state.isLoadingMyLinks = false;
      state.errorMyLinks = null;
    },
    getMyLinksFailure: (state, action) => {
      state.isLoadingMyLinks = false;
      state.errorMyLinks = action.payload;
    },
    
    // Reset
    resetReferralState: (state) => {
      return initialState;
    },
  },
});

export const {
  generateLinkStart,
  generateLinkSuccess,
  generateLinkFailure,
  validateCodeStart,
  validateCodeSuccess,
  validateCodeFailure,
  trackClickStart,
  trackClickSuccess,
  trackClickFailure,
  getMyLinksStart,
  getMyLinksSuccess,
  getMyLinksFailure,
  resetReferralState,
} = referralLinkSlice.actions;

export default referralLinkSlice.reducer;
